import { css } from "@emotion/css";
import game3rdApi from "apis/game3rdApi";
import globalStyle from "constants/global.style";
import HandlerError from "helper/HandlerError";
import { itemGame3RD } from "models/fundTransferModel";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

interface Props {
    onClose: () => void;
    itemGame: itemGame3RD;
}

const PROVIDER_EXTRA_PARAMS: Record<string, object> = {
    IBC2: { platform: 1 },
    DG: { gameId: 'DG' },
    PRAG: { gameId: 'PRAG' },
    EVOLUTION: { gameId: 'EVOLUTION' },
};

const handleLaunchGame = (provider: string, data: any, navigate: ReturnType<typeof useNavigate>) => {
    const openInNewTab = (url: string) => window.open(url, '_blank');

    switch (provider) {
        case "CMD368":
            if (data.cmdLaunchGame) {
                const { webRoot, userName, token } = data.cmdLaunchGame;
                const link = `${webRoot}/auth.aspx?lang=vi-VN&user=${userName}&token=${token}&currency=VD&templatename=green&view=v1`;
                openInNewTab(link);
            }
            break;
        case "IBC2":
            if (data.error_code === 11000 || !data.ibcSessionToken) {
                toast.error("Đang bảo trì, vui lòng quay lại sau!");
            } else {
                openInNewTab(data.ibcSessionToken);
            }
            break;
        case "BTI":
        case "AG":
        case "WM":
        case "SA":
        case "SG":
        case "V8":
            openInNewTab(data.webUrl || data.linkGameForward || data.wmSessionToken || data.url || data.gameLaunchUrl);
            break;
        case "HABA":
        case "DS":
        case "JILI":
        case "PGSOFT":
        case "PT":
            navigate(`/slots?idgame=${provider}`);
            break;
        case "DG":
        case "PRAG":
        case "EVOLUTION":
            if (Array.isArray(data.listUrl) && data.listUrl[0]) {
                openInNewTab(data.listUrl[0]);
            }
            break;
        default:
            toast.error("Không hỗ trợ nhà cung cấp này.");
            break;
    }
};

export default function OpenGame3RD({ onClose, itemGame }: Props) {
    const navigate = useNavigate();

    const loginAndLaunchGame = async () => {
        const { providercode = '', port = '', valSname = '', valSvalue = '' } = itemGame;

        const payload = {
            action: port,
            sname: valSname,
            svalue: valSvalue,
            ...PROVIDER_EXTRA_PARAMS[providercode],
        };

        try {
            const { data } = await game3rdApi.Login3RD(payload);
            HandlerError(data, () => {
                if (data.msg || data.message) {
                    toast.error(data.msg || data.message);
                    return;
                }
                onClose();
                handleLaunchGame(providercode, data, navigate);
            }, port);
        } catch (error) {
            toast.error("Đã có lỗi xảy ra khi đăng nhập game.");
        }
    };

    return (
        <div className={styles.modalGame}>
            <p className={styles.title}>Chuyển quỹ thành công</p>
            <img
                className={styles.imgGame}
                src={require(`assets/images/fundtransfer/${itemGame.providercode.toLowerCase()}_icon.png`)}
                alt="game-icon"
            />
            <div className={styles.action}>
                <button type="button" className={globalStyle.btnSecondary} onClick={loginAndLaunchGame}>
                    Vào Trò Chơi
                </button>
                <button type="button" className={globalStyle.btnPrimary} onClick={onClose}>
                    Huỷ
                </button>
            </div>
        </div>
    );
}

const styles = {
    modalGame: css`
        background: rgba(255, 255, 255, 0.9);
        padding: 20px;
        border-radius: 20px;
        text-align: center;
        margin: 0 auto;
        min-width: 420px;
    `,
    title: css`
        color: #038787;
        font-size: 16px;
        margin-bottom: 0;
    `,
    imgGame: css`
        width: 80%;
        margin: 30px auto;
    `,
    action: css`
        display: flex;
        gap: 12px;
        justify-content: center;
    `,
};
